import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import {
    toDataSourceRequestString,
    translateDataSourceResultGroups,
    translateAggregateResults,
    DataResult,
    DataSourceRequestState
} from "@progress/kendo-data-query";
import { AuthorizationService } from './authorization.service';
import { EnvironmentService } from '../../services/environment.service';

@Injectable()
export class CardService {
    private APPBASE_URL: string;

    constructor(private http: Http, private auth: AuthorizationService, private environment: EnvironmentService) {
        this.APPBASE_URL = environment.APPBASE_URL;
    }

    public fetchMasterminds(state: DataSourceRequestState): Observable<DataResult> {
        const queryStr = `${toDataSourceRequestString(state)}`; //serialize the state

        return this.http.get(`${this.APPBASE_URL}/Legendary/MastermindsRead?${queryStr}`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json())
            .map(response => (<GridDataResult>{
                    data: response.Data,
                    total: response.Total
                })
            );
    }

    public saveMastermind(data: any, isNew?: boolean): Observable<any> {
        let headers = this.auth.postAuthHeader();
        const action = isNew ? 'MastermindsCreate' : 'MastermindsUpdate';
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Legendary/${action}`, JSON.stringify(value), { headers: headers });
    }

    public removeMastermind(id: number): Observable<any>  {
        return this.http.get(`${this.APPBASE_URL}/Legendary/MastermindsDestroy/${id}`, { headers: this.auth.getAuthHeader() });
    }

    public fetchHeroes(state: DataSourceRequestState): Observable<DataResult> {
        const queryStr = `${toDataSourceRequestString(state)}`; //serialize the state

        return this.http.get(`${this.APPBASE_URL}/Legendary/HeroesRead?${queryStr}`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json())
            .map(response => (<GridDataResult>{
                data: response.Data,
                total: response.Total
            })
            );
    }

    public saveHero(data: any, isNew?: boolean): Observable<any> {
        let headers = this.auth.postAuthHeader();
        const action = isNew ? 'HeroCreate' : 'HeroUpdate';
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Legendary/${action}`, JSON.stringify(value), { headers: headers });
    }

    public removeHero(id: number): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/HeroDestroy/${id}`, { headers: this.auth.getAuthHeader() });
    }

    public fetchVillains(state: DataSourceRequestState): Observable<DataResult> {
        const queryStr = `${toDataSourceRequestString(state)}`;

        return this.http.get(`${this.APPBASE_URL}/Legendary/VillainsRead?${queryStr}`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json())
            .map(response => (<GridDataResult>{
                data: response.Data,
                total: response.Total
            })
            );
    }

    public saveVillain(data: any, isNew?: boolean): Observable<any> {
        let headers = this.auth.postAuthHeader();
        const action = isNew ? 'VillainCreate' : 'VillainUpdate';
        const value = data;

        return this.http.post(`${this.APPBASE_URL}/Legendary/${action}`, JSON.stringify(value), { headers: headers });
    }

    public removeVillain(id: number): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/VillainDestroy/${id}`, { headers: this.auth.getAuthHeader() });
    }

    public fetchTypes(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/Types`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public fetchVillainGroups(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/VillainGroups`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }

    public fetchTeams(): Observable<any> {
        return this.http.get(`${this.APPBASE_URL}/Legendary/Teams`, { headers: this.auth.getAuthHeader() })
            .map(response => response.json());
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/services/card.service.ts